import { createGlobalStyle } from 'styled-components'
import NotoSansBold from './NotoSansKR-Bold.otf'
import NotoSansRegular from './NotoSansKR-Regular.otf'
import NotoSansMedium from './NotoSansKR-Medium.otf'
import NanumSquareNeoExtraBold from './NanumSquareNeoTTF-dEb.woff'
import NanumSquareNeoHeavy from './NanumSquareNeoTTF-eHv.woff'
import NanumSquareNeoRegular from './NanumSquareNeoTTF-bRg.woff'

export const FontGlobal = createGlobalStyle`
  @font-face { //400
    font-family: 'NotoSansRegular';
    src: local('NotoSansRegular'), local('NotoSansRegular');
    font-style: normal;
    src: url(${NotoSansRegular}) format('truetype');
  }
  @font-face { // 500
    font-family: 'NotoSansMedium';
    src: local('NotoSansMedium'), local('NotoSansMedium');
    font-style: normal;
    src: url(${NotoSansMedium}) format('truetype');
  }
  @font-face { // 700
    font-family: 'NotoSansBold';
    src: local('NotoSansBold'), local('NotoSansBold');
    font-style: normal;
    src: url(${NotoSansBold}) format('truetype');
  }
  @font-face { // 700
    font-family: 'NanumSquareNeoRegular';
    src: local('NanumSquareNeoRegular'), local('NanumSquareNeoRegular');
    font-style: normal;
    src: url(${NanumSquareNeoRegular}) format('truetype');
  }
  @font-face { // 800
    font-family: 'NanumSquareNeoExtraBold';
    src: local('NanumSquareNeoExtraBold'), local('NanumSquareNeoExtraBold');
    font-style: normal;
    src: url(${NanumSquareNeoExtraBold}) format('truetype');
  }
  @font-face { // 900
    font-family: 'NanumSquareNeoHeavy';
    src: local('NanumSquareNeoHeavy'), local('NanumSquareNeoHeavy');
    font-style: normal;
    src: url(${NanumSquareNeoHeavy}) format('truetype');
  }
`
